module.exports = __webpack_public_path__ + "img/tn-timeline-main-13.4719000d.jpg";